import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetExpenseDetailsQuery } from "../../../services/Reports";
import {
  getExpenseDetailsRequest,
  getExpenseDetailsFailure,
  getExpenseDetailsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allExpenseDetails,
    isLoading: expenseDetailsLoading,
    isError: expenseDetailsError,
  } = useGetExpenseDetailsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.expenseDetailsPageNo,
    pageSize: state.expenseDetailsPageSize,
    fromDate: new Date(state.expenseDetailsFromDate).toLocaleDateString(),
    toDate: new Date(state.expenseDetailsToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (expenseDetailsLoading) {
      dispatch(getExpenseDetailsRequest());
    }
    if (expenseDetailsError) {
      dispatch(getExpenseDetailsFailure(expenseDetailsError));
    }
    if (allExpenseDetails) {
      dispatch(
        getExpenseDetailsSuccess({
          data: allExpenseDetails.data.expenseDetails[0].data || [],
          totalPages:
            allExpenseDetails.data.expenseDetails[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allExpenseDetails,
    profileData,
    state.expenseDetailsFromDate,
    state.expenseDetailsToDate,
    state.expenseDetailsPageNo,
    state.expenseDetailsPageSize,
  ]);
  return <></>;
};
export default Content;
